import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Contract} from '../model/Entities/Contract';
import {Observable} from 'rxjs/Observable';

import * as moment from 'moment';
import {Filter} from '../model/Helpers/Filter';
import {Pagination} from '../model/Helpers/Pagination';
import {SortInfo} from '../model/Helpers/SortInfo';
import {ContractItem} from '../model/Entities/ContractItem';
import {ContractItemType} from '../model/Entities/ContractItemType';
import {DeliveryContractItem} from '../model/Entities/DeliveryContractItem';
import {DeploymentContractItem} from '../model/Entities/DeploymentContractItem';
import {ProductContractItem} from '../model/Entities/ProductContractItem';

@Injectable()
export class ContractService extends ApiService<Contract> {

    protected apiUrl = 'api/contracts';  // URL to web api

    protected getObjectType(): any {
        return Contract;
    }

    get(id: Number, params: Object = {}): Observable<Contract> {
        return super.get(id, params).map((data: Contract) => {
            data.fromStart = moment(data.fromStart).toDate();
            data.toStart = moment(data.toStart).toDate();
            data.fromEnd = moment(data.fromEnd).toDate();
            data.toEnd = moment(data.toEnd).toDate();

            return data;
        });
    }

    getPaginatedList(pagination: Pagination = null, sort: SortInfo = null, filters: Filter[] = [], params: Object = {}): Observable<any> {
        return super.getPaginatedList(pagination, sort, filters, params).map((data) => {
            data.results = this.mapItemsExpand(data.results);
            return data;
        });
    }

    private mapItemsExpand(data: Contract[]) {
        for (let i = 0; i < data.length; i++) {
            data[i].items = this.expandContractItems(data[i].items);
            data[i].lostItems = this.expandContractItems(data[i].lostItems);
        }

        return data;
    }

    private expandContractItems(items: ContractItem[]) {
        for (let i = 0; i < items.length; i++) {
            switch (items[i].type) {
                case ContractItemType.delivery:
                    items[i] = Object.assign(new DeliveryContractItem(), this.objectResponseToCamelCase(items[i]));
                    break;
                case ContractItemType.deployment:
                    items[i] = Object.assign(new DeploymentContractItem(), this.objectResponseToCamelCase(items[i]));
                    break;
                default:
                    items[i] = Object.assign(new ProductContractItem(), this.objectResponseToCamelCase(items[i]));
            }
        }

        return items;
    }
}



// WEBPACK FOOTER //
// /app/src/services/contract.service.ts